import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 text-center" }
const _hoisted_4 = { key: 1 }

import routes from "@/core/router/routes";
import {useSettingsStore} from "@/core/stores/settings_store";
import {computed, onBeforeMount} from "vue";
import Modes from "@/core/models/Modes";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const settingsStore = useSettingsStore();
const canSurveyBeShown = computed(() => {
  return settingsStore.mode == Modes.Operator || !settingsStore.surveyCompleted;
});

onBeforeMount(() => {
  settingsStore.setMode();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("h2", null, [
          _createTextVNode("Le risposte della salute: "),
          _createElementVNode("span", { class: "viola" }, "Questionario OnLine"),
          _createTextVNode(" sulla Prevenzione")
        ], -1)),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "intro" }, " Obiettivo del questionario è renderti più consapevole su temi delicati come l'incidenza delle malattie croniche non trasmissibili, la loro prevenzione e la diagnosi precoce, l’utilità di una polizza sanitaria che ti aiuti a fare prevenzione. Rispondi alle domande sul tuo stile di vita, su quante persone si ammalano in Italia e sugli esami di controllo che esegui regolarmente. ", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "margin-t-50" }, [
          _createTextVNode(" DISCLAIMER "),
          _createElementVNode("br"),
          _createTextVNode(" Il Questionario on line ha esclusivamente finalità divulgative e di promozione della prevenzione della malattia senza nessuna finalità di autodiagnosi o di automedicazione. "),
          _createElementVNode("br"),
          _createTextVNode("Esso non costituisce parere professionale medico. I dati raccolti con il Questionario on line sono anonimi e in nessun modo riconducibili all’Utente. "),
          _createElementVNode("br"),
          _createElementVNode("br"),
          _createElementVNode("small", null, [
            _createTextVNode(" Leggi le "),
            _createElementVNode("a", {
              href: "/privacy.pdf",
              target: "_blank",
              class: "text-decoration-underline"
            }, " Note Legali e Informativa Privacy ")
          ])
        ], -1)),
        (canSurveyBeShown.value)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: _unref(routes).survey.path,
              class: "btn margin-b-40"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" RISPONDI AL QUESTIONARIO ", -1)
              ]))]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createElementBlock("p", _hoisted_4, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("span", { class: "bg-primary text-white badge badge-" }, "Hai già risposto al questionario", -1)
            ]))]))
      ])
    ])
  ]))
}
}

})